module.exports = __webpack_public_path__ + "static/media/IMG_1994.678b373c.jpg";